angular.module('pe4h').controller('Projects', function ($scope, $rootScope, $http, $state, $uibModal, $window, $uibModalStack) {

  var actionFunctions = {
    "request-an-invoice": requestInvoice,
    "review-invoice": openReviewInvoiceModalWithMessage,
    "fund-escrow": fundEscrow,
    "release-funds": openReleaseOfFundsModal,
    "request-revised-invoice": openRequestRevisedInvoiceModal
  };

  var paymentMethodFunctions = {
    "wire-transfer": openModalWithWireTransferInformation,
    "credit-card": redirectToPaymentSteps
  };

  $scope.getProjects = function () {
    $http({
      url: configuration.webApi.projects.projects,
      method: "GET",
      data: {},
    }).success(function (res, status, headers, config) {
      $scope.projectsAll = res;
      $scope.projects = res;
      $scope.paging.total = $scope.projectsAll.length;
      $scope.createPaginationList();
      if ($state.params.uid) {
        var currentProject = $scope.projects.find(function (project) {
          return project.UID == $state.params.uid;
        });
        callProjectAction(currentProject, actionFunctions);
      }
      else if ($state.params.token) {
        setPaymentSubmitted($state.params.token);
      }
    }).error(function (error, status, headers, config) {
      //authFactory.logout();
    });
  };

  function setPaymentSubmitted(token){
    $http({
      url: configuration.webApi.projects.paymentSubmitted,
      method: "POST",
      headers: { token },
      data: {},
    }).success(function (res, status, headers, config) {
      openPaymentSubmittedModal();
    }).error(function (error, status, headers, config) {
      $scope.alertErrorFromServer(error, function(){
        $state.go('projects', {uid: null, token: null});
      });
    });
  }

  function openPaymentSubmittedModal(){
    $scope.paymentSubmittedMessage = $scope.getMessagesParagraphs("paymentSubmittedMessage");

    var modalPaymentSubmitted = $uibModal.open({
      templateUrl: 'modal-payment-submitted.html',
      size: 'md',
      windowClass: "escrowModal",
      scope: $scope,
      controller: ["$scope", "$uibModalInstance", "$q", "$state", "Upload", function ($scope, $uibModalInstance, Upload) {

      }]
    });
    modalPaymentSubmitted.closed.then(function (data) {
      $state.go('projects', {uid: null, token: null});
    });
  }

  function callProjectAction(currentProject, actionFunctions) {
    var actionFromStatus = currentProject && configuration.status_action.project[currentProject.Status];
    if (currentProject && actionFromStatus) {
      var actionId = actionFromStatus['action_id'];
      var actionFunction = actionFunctions[actionId];
      if (actionFunction) {
        actionFunction(currentProject.Id, actionId, currentProject);
      }
    }
  }

  $scope.generateSeoUrlForProject = function (project) {
    var seoTitle = "contract " + project.LicenseLabel + " job in " + project.City;
    return seoTitle.toLowerCase().replace(/ /g, "-");
  }

  $scope.isFull = function (proj) {
    return (proj.ProposalsCount >= $scope.maxProposals && !proj.IsPublic && proj.Status == 'open')
  }

  $scope.$watch('paging.mode', function (newValue, oldValue) {
    $scope.createPaginationList();
  });
  $scope.createPaginationList = function () {
    var pageCount = Math.ceil($scope.paging.total / $scope.paging.mode);
    $scope.projectsPaginated = [];
    $scope.projects = [];
    for (var i = 0; i < pageCount; i++) {
      var values = $scope.projectsAll.slice($scope.paging.mode * i, $scope.paging.mode * i + $scope.paging.mode);
      $scope.projectsPaginated[i] = values;
    };
    $scope.goToPage(1);
  };

  $scope.goToPage = function (page) {
    $scope.paging.current = page;
    if (1 <= page && page <= $scope.projectsPaginated.length) {
      $scope.projects = $scope.projectsPaginated[page - 1];
    }
    $scope.goToTop();
  };

  $scope.existsStatus = function (projectStatus) {
    var exists = typeof configuration.status_action.project[projectStatus] !== 'undefined';
    return exists;
  }

  $scope.getStatusAction = function (projectStatus) {
    if ($scope.existsStatus(projectStatus))
      return configuration.status_action.project[projectStatus].action_name;
    else
      return 'Action Not Available';
  }

  function requestInvoice(projectId, actionId){
    $http({
      url: configuration.webApi.invoices.requestInvoice({ projectId: projectId }),
      method: "POST",
      data: {},
    }).success(function (res, status, headers, config) {
      openInvoiceRequestSentModal();
    }).error(function (error, status, headers, config) {
      $scope.alertErrorFromServer(error, function(){
        $state.go('projects', {uid: null});
      });
    });
  }

  function openInvoiceRequestSentModal(){
    $scope.requestInvoiceMessage = $scope.getMessagesParagraphs("requestInvoiceMessage");

    var modalRequestInvoice = $uibModal.open({
      templateUrl: 'modal-request-invoice.html',
      size: 'md',
      windowClass: "escrowModal",
      scope: $scope,
      controller: ["$scope", "$uibModalInstance", "$q", "$state", "Upload", function ($scope, $uibModalInstance, Upload) {
      }]
    });
    modalRequestInvoice.closed.then(function (data) {
      $state.go('projects', {uid: null});
    });
  }

  function openReviewInvoiceModalWithMessage(projectId, actionId) {
    $http({
      url: configuration.webApi.invoices.getPendingInvoice({ projectId: projectId }),
      method: "GET",
      data: {},
    }).success(function (res, status, headers, config) {
      openReviewInvoiceModal(projectId, actionId, res.Engineer.FullName, res.Note, res.Attachments, res.TotalWithFee);
    }).error(function (error, status, headers, config) {
      $scope.alertErrorFromServer(error, function(){
        $state.go('projects', {uid: null});
      });
    });
  }

  function openApproveInvoiceConfirmationModal(projectId, invoiceText) {
    var modalInvoiceApproveConfirmation = $uibModal.open({
      backdrop: 'static',
      keyboard: false,
      templateUrl: 'modal-invoice-approve-confirmation.html',
      size: 'md',
      windowClass: "escrowMiniConfirmationModal",
      scope: $scope,
      controller: ["$scope", "$uibModalInstance", "$q", "$state", "Upload", function ($scope, $uibModalInstance, Upload) {

        $scope.approveInvoice = function () {
          $scope.approvingInvoice = true;
          $http({
            url: configuration.webApi.invoices.approveInvoice({
              projectId: projectId,
            }),
            method: "POST",
            data: {
              "clientMessage": invoiceText
            },
          }).success(function (res, status, headers, config) {
            var clientVerification = res.clientResponse.verification;
            if (clientVerification.verificationRequired && clientVerification.verificationLink) {
              $scope.approvingInvoice = false;
              openVerifyAccountModal("Invoice Approved!", "verifyEscrowAccountMessage", clientVerification.verificationLink)
            }
            else {
              $scope.approvingInvoice = false;
              openApproveInvoiceModal(projectId);
            }

          }).error(function (error, status, headers, config) {
            $scope.alertErrorFromServer(error, function () {
              $uibModalStack.dismissAll()
            });
          });
        }

        modalInvoiceApproveConfirmation.closed.then(function (data) {
          $state.go('projects', {uid: null});
        });

      }]
    });
  }

  function openApproveInvoiceModal(projectId) {
    $scope.invoiceApprovedMessage = $scope.getMessagesParagraphs("approvedInvoiceMessage");

    var modalInvoiceApproved = $uibModal.open({
      templateUrl: 'modal-invoice-approve.html',
      size: 'md',
      windowClass: "escrowModal",
      scope: $scope,
      controller: ["$scope", "$uibModalInstance", "$q", "$state", "Upload", function ($scope, $uibModalInstance, Upload) {
        $scope.fundEscrowAfterApprovement = function () {
          var fundEscrow = actionFunctions["fund-escrow"];
          fundEscrow(projectId);
        }
      }]
    });
    modalInvoiceApproved.closed.then(function (data) {
      $uibModalStack.dismissAll()
    });
  }

  function openRequestRevisedInvoiceModal(projectId, actionId) {
    $http({
      url: configuration.webApi.invoices.requestRevisedInvoice({ projectId: projectId }),
      method: "POST",
      data: {},
    }).success(function (res, status, headers, config) {
      openRequestRevisedInvoiceConfirmationModal(actionId);
    }).error(function (error, status, headers, config) {
      $scope.alertErrorFromServer(error, function(){
        $state.go('projects', {uid: null});
      });
    });
  }

  function openRequestRevisedInvoiceConfirmationModal(actionId) {
    $scope.requestRevisedInvoiceConfirmationMessage = $scope.getMessagesParagraphs("requestRevisedInvoiceConfirmationMessage");

    var requestRevisedInvoiceConfirmationModal = $uibModal.open({
      templateUrl: `modal-${actionId}-confirmation.html`,
      size: 'md',
      windowClass: "escrowModal",
      scope: $scope,
      controller: ["$scope", "$uibModalInstance", "$q", "$state", "Upload", function ($scope, $uibModalInstance, Upload) {
      }]
    });
    requestRevisedInvoiceConfirmationModal.closed.then(function (data) {
      $state.go('projects', {uid: null});
    });
  }

  function openVerifyAccountModal(invoiceTitle, messageTopCode, verificationLink) {
    $scope.title = invoiceTitle;
    $scope.verifyEscrowAccountMessage = $scope.getMessagesParagraphs(messageTopCode);
    $scope.verificationStatus = verificationLink ? "not_verified" : "pending";

    var modalverifyEscrowAccount = $uibModal.open({
      templateUrl: 'modal-verify-account.html',
      size: 'md',
      windowClass: "escrowModal",
      scope: $scope,
      controller: ["$scope", "$uibModalInstance", "$q", "$state", "Upload", function ($scope, $uibModalInstance, Upload) {
        $scope.redirectToVerifyAccount = function () {
          window.open(verificationLink, "_self")
        }
      }]
    });
    modalverifyEscrowAccount.closed.then(function (data) {
      $state.go('projects', {uid: null});
    });
  }

  function openRejectInvoiceConfirmationModal(projectId, invoiceText) {

    var modalInvoiceRejectConfirmation = $uibModal.open({
      backdrop: 'static',
      keyboard: false,
      templateUrl: 'modal-invoice-reject-confirmation.html',
      size: 'md',
      windowClass: "escrowMiniConfirmationModal",
      scope: $scope,
      controller: ["$scope", "$uibModalInstance", "$q", "$state", "Upload", function ($scope, $uibModalInstance, Upload) {

        $scope.rejectInvoice = function () {
          $scope.rejectingInvoice = true;
          $http({
            url: configuration.webApi.invoices.rejectInvoice({
              projectId: projectId,
            }),
            method: "POST",
            data: {
              "clientMessage": invoiceText
            },
          }).success(function (res, status, headers, config) {
            openRejectInvoiceModal();
          }).error(function (error, status, headers, config) {
            $scope.alertErrorFromServer(error, function () {
              $uibModalStack.dismissAll()
            });
          });
        }

        modalInvoiceRejectConfirmation.closed.then(function (data) {
          $state.go('projects', {uid: null});
        });

      }]
    });
  }

  function openRejectInvoiceModal() {
    $scope.invoiceRejectedMessage = $scope.getMessagesParagraphs("rejectedInvoiceMessage");

    var modalInvoiceRejected = $uibModal.open({
      templateUrl: 'modal-invoice-rejected.html',
      size: 'md',
      windowClass: "escrowModal",
      scope: $scope,
      controller: ["$scope", "$uibModalInstance", "$q", "$state", "Upload", function ($scope, $uibModalInstance, Upload) {
      }]
    });
    modalInvoiceRejected.closed.then(function (data) {
      $uibModalStack.dismissAll()
    });
  }

  function openReviewInvoiceModal(projectId, actionId, from, note, attachments, total) {
    var modalReviewInvoice = $uibModal.open({
      templateUrl: 'modal-' + actionId + '.html',
      size: 'md',
      windowClass: "escrowModal",
      scope: $scope,
      controller: ["$scope", "$uibModalInstance", "$q", "$state", "Upload", function ($scope, $uibModalInstance, Upload) {
        function init() {
          $scope.reviewInvoiceMessage = $scope.getMessagesParagraphs("reviewInvoiceMessage");
          $scope.maxInvoiceLength = 2000;
          $scope.remainingCharacters = $scope.maxInvoiceLength;
          $scope.invoiceText = "";
          $scope.from = from;
          $scope.note = note;
          $scope.attachments = attachments;
          $scope.total = total;
          $scope.projectId = projectId;
        }

        $scope.rejectInvoiceConfirmation = function () {
          openRejectInvoiceConfirmationModal(projectId, $scope.invoiceText);
        }

        $scope.approveInvoiceConfirmation = function () {
          openApproveInvoiceConfirmationModal(projectId, $scope.invoiceText);
        }

        $scope.updateCharactersLeft = function () {
          var invoiceLength = $scope.invoiceText ? $scope.invoiceText.length : 0;
          $scope.remainingCharacters = $scope.maxInvoiceLength - invoiceLength;
        }

        init();

        modalReviewInvoice.closed.then(function (data) {
          $state.go('projects', {uid: null});
        });
      }]
    });
  }

  function fundEscrow(projectId, actionId) {
    $http({
      url: configuration.webApi.projects.paymentInformation({
        id: projectId,
      }),
      method: "GET"
    }).success(function (res, status, headers, config) {
      if (res && res.paymentMethod) {
        var paymentFunction = paymentMethodFunctions[res.paymentMethod];
        paymentFunction(res.information, projectId);
      }
      else if (res && res.error) {
        if (res.error == "verificationRequired") {
          var verificationLink = res.verificationLink;
          var topMessageCode = verificationLink ? 'verifyEscrowAccountMessage' : 'verificationPendingMessage'
          openVerifyAccountModal("Verification Required!", topMessageCode, verificationLink);
        }
      }
      else {
        $scope.alertErrorFromServer({ Code: "emptyResponse", Detail: "Could not find payment method" });
      }
    }).error(function (error, status, headers, config) {
      $scope.alertErrorFromServer(error, function() {
        $state.go('projects', {uid: null});
      });
    });
  }

  function redirectToPaymentSteps(landingPage, projectId) {
    if (landingPage) {
      window.open(landingPage, "_self");
    }
    else {
      $scope.alertErrorFromServer({ Code: "emptyLandingPage", Detail: "Could not get payment link" });
    }
  }

  function redirectToPrintDetails(url) {
    $window.open(url);
  }

  function openModalWithWireTransferInformation(wireTransferInformation, projectId) {
    if (wireTransferInformation) {
      $scope.confirmWireTransferMessage = $scope.getMessagesParagraphs("confirmWireTransferMessage");
      $scope.wireTransferStepsMessage = $scope.getMessagesParagraphs("wireTransferStepsMessage", "creditCardLimit");

      $scope.wireTransferInformation = wireTransferInformation;

      var modalWireTransferInformation = $uibModal.open({
        templateUrl: 'modal-wire-transfer-info.html',
        size: 'md',
        windowClass: "escrowModal",
        scope: $scope,
        controller: ["$scope", "$uibModalInstance", "$q", "$state", "Upload", function ($scope, $uibModalInstance, Upload) {
          function init() {
            $scope.bankName = $scope.wireTransferInformation && $scope.wireTransferInformation.bank_name;
            $scope.bankAddress = $scope.wireTransferInformation && $scope.wireTransferInformation.bank_address;
            $scope.routingNumber = $scope.wireTransferInformation && $scope.wireTransferInformation.routing_number;
            $scope.swiftCode = $scope.wireTransferInformation && $scope.wireTransferInformation.swift_code;
            $scope.creditAccountName = $scope.wireTransferInformation && $scope.wireTransferInformation.credit_account_name;
            $scope.creditAccountNumber = $scope.wireTransferInformation && $scope.wireTransferInformation.credit_account_number;
          }

          $scope.openWireTransferPaymentConfirmationModal = function () {
            openWireTransferPaymentConfirmationModal(projectId);
          }

          $scope.printDetails = function () {
            var printUrl = $scope.wireTransferInformation && $scope.wireTransferInformation.print_url;
            redirectToPrintDetails(printUrl);
          }

          init();

          modalWireTransferInformation.closed.then(function (data) {
            $state.go('projects', {uid:null});
          });
        }]
      });
    }
    else {
      $scope.alertErrorFromServer({ Code: "emptyWireTransferInformation", Detail: "Could not get wire transfer information" });
    }
  }

  function openPaymentConfirmedModal() {
    $scope.paymentConfirmationMessage = $scope.getMessagesParagraphs("paymentConfirmedMessage");

    var modalInvoiceApproved = $uibModal.open({
      templateUrl: 'modal-payment-confirmed.html',
      size: 'md',
      windowClass: "escrowModal",
      scope: $scope,
      controller: ["$scope", "$uibModalInstance", "$q", "$state", "Upload", function ($scope, $uibModalInstance, Upload) {
      }]
    });
    modalInvoiceApproved.closed.then(function (data) {
      $uibModalStack.dismissAll()
    });
  }

  function openWireTransferPaymentConfirmationModal(projectId) {
    var modalPaymentConfirmation = $uibModal.open({
      backdrop: 'static',
      keyboard: false,
      templateUrl: 'modal-wire-transfer-confirmation.html',
      size: 'md',
      windowClass: "escrowMiniConfirmationModal",
      scope: $scope,
      controller: ["$scope", "$uibModalInstance", "$q", "$state", "Upload", function ($scope, $uibModalInstance, Upload) {

        $scope.confirmingPayment = false;

        $scope.confirmPayment = function () {
          $scope.confirmingPayment = true;
          $http({
            url: configuration.webApi.projects.confirmPayment({
              id: projectId,
            }),
            method: "POST"
          }).success(function (res, status, headers, config) {
            confirmingPayment = false;
            openPaymentConfirmedModal();
          }).error(function (error, status, headers, config) {
            $scope.confirmingPayment = false;
            $scope.alertErrorFromServer(error);
          });
        }


        modalPaymentConfirmation.closed.then(function (data) {
          $state.go('projects', {uid: null});
        });

      }]
    });
  }

  function openReleaseOfFundsModal(projectId, actionId, project){
    $scope.releaseOfFundsMessage = $scope.getMessagesParagraphs("releaseOfFundsMessage");

    var modalReleaseOfFunds = $uibModal.open({
      backdrop: 'static',
      keyboard: false,
      templateUrl: 'modal-release-of-funds.html',
      size: 'md',
      windowClass: "escrowModal",
      scope: $scope,
      controller: ["$scope", "$uibModalInstance", "$q", "$state", "Upload", function ($scope, $uibModalInstance, Upload) {
        
        $scope.releaseFunds = function(){
          $scope.releasingFunds = true;
          $http({
            url: configuration.webApi.projects.releaseFunds({
              id: projectId,
            }),
            method: "POST"
          }).success(function (res, status, headers, config) {
            releasingFunds = false;
            openFundsReleasedModal(project);
          }).error(function (error, status, headers, config) {
            $scope.releasingFunds = false;
            $scope.alertErrorFromServer(error);
          });
        }
      
        $scope.close = function(){
          if(!$scope.releasingFunds){
            $uibModalStack.dismissAll();
          }
        }

      }]
    });
    modalReleaseOfFunds.closed.then(function (data) {
      $state.go("projects", {uid: null});
    });
  }

  function openFundsReleasedModal(project) {
    $scope.fundsReleasedMessage = $scope.getMessagesParagraphs("fundsReleasedMessage");
    $scope.project = project;
    $scope.reviewUrl = $scope.generateSeoUrlForProject(project) + "/rfp/" + $scope.project.UID;

    var modalFundsReleased = $uibModal.open({
      templateUrl: 'modal-funds-released.html',
      size: 'md',
      windowClass: "escrowModal",
      scope: $scope,
      controller: ["$scope", "$uibModalInstance", "$q", "$state", "Upload", function ($scope, $uibModalInstance, Upload) {
        
      $scope.redirectToSubmitReview = function(){
        $window.location.href = $scope.reviewUrl;
      }

      }]
    });
    modalFundsReleased.closed.then(function (data) {
      $uibModalStack.dismissAll()
    });
  }

  function init() {
    $scope.first = $state.params.first;

    // Paging
    $scope.paging = {};
    $scope.paging.values = [25, 100, Number.MAX_SAFE_INTEGER];
    $scope.paging.display = ["25", "100", "list all"];
    $scope.paging.mode = $scope.paging.values[0];
    $scope.paging.current = 1;
    $scope.getProjects();
  }
  init();
});